<template>
  <Author :author="author" :posts="posts" />
</template>
<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Author from '../../../components/Blog/Author';

export default {
  components: { Author },
  mixins: [global],
  async asyncData({
    $axios, route, $config, error,
  }) {
    const author = await $axios
      .$get(`/team/all/${route.params.author}`)
      .catch(() => false);

    if (!author) {
      return error({ title: 'Not found', statusCode: 404, message: 'Author not found' });
    }

    author.fullPath = `${$config.siteUrl}${route?.fullPath}`;

    const posts = author.postsArr;
    const currentPage = +route.query.page || 1;

    return {
      author,
      posts,
      currentPage,
    };
  },
  head() {
    let metaTitle = `${this.author.name} – Author`;
    if (this.currentPage > 1) {
      metaTitle += ` - Page ${this.currentPage}`;
    }
    const metaDescription = `Get to know our author ${this.author.name}. Learn more about their education, work experience, and courses at 365 Data Science. Start now!`;
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: { ...this.page, metaTitle, metaDescription } },
      {
        key: 'Person',
        values: {
          name: this.author.name,
          url: `${this.$config.siteUrl}${this.$route.fullPath}`,
          image: {
            '@type': 'ImageObject',
            url: `${this.$config.imagesUrl}/team/${this.author.image}`,
            caption: `${this.author.name}'s image`,
          },
        },
      },
    ]);

    return {
      titleTemplate: `${metaTitle}%s`,
      link: [{ rel: 'canonical', href: this.canonicalURL() }],
      meta: this.metaProps({
        ...this.author,
        metaTitle,
        metaDescription,
      }),
      script: [linkedData],
    };
  },
};
</script>
